module.exports = __webpack_public_path__ + "img/nmg-td.29b7a404.jpg";